export const supportUrl = 'https://desk.zoho.com/portal/emrit';
